/**
 * Utilidades para obtener nombres correctos de superficies dentales
 * basados en la nomenclatura dental estándar
 */

/**
 * Obtiene el nombre correcto de una superficie dental basado en el diente y superficie
 * @param {string} toothLabel - Etiqueta del diente (ej: '1.1', '2.6')
 * @param {string} surfaceKey - Clave de superficie ('top', 'right', 'bottom', 'left', 'center')
 * @returns {string} - Nombre correcto de la superficie
 */
export const getSurfaceName = (toothLabel, surfaceKey) => {
  const toothNumber = toothLabel.replace('.', '');
  const quadrant = toothNumber.charAt(0);
  
  switch (surfaceKey) {
    case 'top': 
      // Cuadrantes superiores (1,2,5,6): top = Vestibular
      // Cuadrantes inferiores (3,4,7,8): top = Lingual
      if (quadrant === '1' || quadrant === '2' || quadrant === '5' || quadrant === '6') {
        return 'Vestibular';
      } else {
        return 'Lingual';
      }
      
    case 'right': 
      // Cuadrantes derechos (1,4): right = Mesial
      // Cuadrantes izquierdos (2,3): right = Distal
      if (quadrant === '1' || quadrant === '4') {
        return 'Mesial';
      } else {
        return 'Distal';
      }
      
    case 'bottom': 
      // Cuadrantes superiores (1,2,5,6): bottom = Palatina
      // Cuadrantes inferiores (3,4,7,8): bottom = Vestibular
      if (quadrant === '1' || quadrant === '2' || quadrant === '5' || quadrant === '6') {
        return 'Palatina';
      } else {
        return 'Vestibular';
      }
      
    case 'left': 
      // Cuadrantes derechos (1,4): left = Distal
      // Cuadrantes izquierdos (2,3): left = Mesial
      if (quadrant === '1' || quadrant === '4') {
        return 'Distal';
      } else {
        return 'Mesial';
      }
      
    case 'center': 
      // El centro siempre es oclusal
      return 'Oclusal';
      
    default: 
      return surfaceKey;
  }
};

/**
 * Obtiene un mapeo de todas las superficies para un diente específico
 * @param {string} toothLabel - Etiqueta del diente
 * @returns {Object} - Objeto con claves de superficie y nombres correctos
 */
export const getSurfaceNamesForTooth = (toothLabel) => {
  return {
    'top': getSurfaceName(toothLabel, 'top'),
    'right': getSurfaceName(toothLabel, 'right'), 
    'bottom': getSurfaceName(toothLabel, 'bottom'),
    'left': getSurfaceName(toothLabel, 'left'),
    'center': getSurfaceName(toothLabel, 'center')
  };
};

/**
 * Lista de todas las superficies en orden
 */
export const SURFACE_KEYS = ['top', 'right', 'bottom', 'left', 'center'];
